import styled from 'styled-components';
import { Stack } from 'common/design-system/components-v2';

const FormFieldsWrapper = styled(Stack)``;

export const AcknowledgeModalStyles = {
    FormFieldsWrapper,
};
